import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Overline, Reveal } from "@/components/motion";
import { getBlog } from "@/lib/api";

export default function TravelInspiration() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    getBlog({ limit: 3 }).then((d) => setPosts(d.slice(0, 3))).catch(() => {});
  }, []);

  if (!posts.length) return null;

  return (
    <section id="blog" data-testid="home-blog" className="relative py-24 sm:py-32 bg-[#faf8f5]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <Overline>Travel Inspiration</Overline>
            <h2 className="font-serif text-[#3b1a1a] text-4xl sm:text-6xl leading-[1.03] tracking-tight mt-5">
              Stories, guides & <span className="italic text-[#14523d]">travel wisdom.</span>
            </h2>
          </div>
          <Link to="/blog" className="inline-flex items-center gap-2 text-xs tracking-[0.24em] uppercase text-[#7c1d1d] hover:gap-3 transition-all">
            Read the Blog <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <Link to={`/blog/${p.slug}`} data-testid={`home-blog-${p.slug}`} className="group block">
                <div className="relative overflow-hidden aspect-[3/2] border border-[#d4af37]/25">
                  <img src={p.featured_image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1200ms]" />
                </div>
                <div className="mt-5">
                  <span className="text-[10px] tracking-[0.24em] uppercase text-[#14523d]">{p.category}</span>
                  <h3 className="font-serif text-2xl text-[#3b1a1a] mt-2 leading-snug group-hover:text-[#7c1d1d] transition-colors clamp-2">{p.title}</h3>
                  <p className="text-sm text-[#5a4b4b] mt-2 leading-relaxed clamp-2">{p.excerpt}</p>
                  <span className="mt-3 inline-flex items-center gap-1.5 text-[11px] tracking-[0.2em] uppercase text-[#7c1d1d]">Read more <ArrowUpRight className="w-3.5 h-3.5" /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
